<template>
  <v-container fluid class="pa-0">
    <Head title="Tentang Kami" />
    <v-img
      :src="require('~/images/bg-about-us.png')"
      :height="$vuetify.breakpoint.mobile ? 400 : 600"
      content-class="d-flex justify-center"
      dark
    >
      <v-container
        class="text-center"
        :class="[
          sectionClass,
          {
            'my-8': !$vuetify.breakpoint.mobile,
          },
        ]"
      >
        <p
          class="font-weight-bold text-elevation-1"
          :class="[$vuetify.breakpoint.mobile ? 'text-h4' : 'text-h2']"
        >
          Tentang Kami
        </p>
        <p
          class="font-weight-bold text-elevation-1"
          :class="[$vuetify.breakpoint.mobile ? 'text-body-1' : 'text-h5']"
        >
          XuYuan Class adalah tempat kursus Bahasa Mandarin secara online dengan
          tim guru yang profesional dan metode pengajaran yang interaktif
        </p>
      </v-container>
    </v-img>
    <v-container :class="sectionClass">
      <v-row align="center">
        <v-col cols="12" md="5">
          <h1 class="primary--text">Our Vision</h1>
          <p>
            Nowadays Chinese Language has become a global language. With the
            current state of technology, Xu Yuan wants to be a forum to reach
            areas that experience educational disparities, especially in Chinese
            language, so that Indonesians can compete with the world of work
            abroad
          </p>
        </v-col>
        <v-col
          v-if="!$vuetify.breakpoint.mobile"
          cols="2"
          class="text-center"
          style="height: 250px"
        >
          <v-divider vertical></v-divider>
        </v-col>
        <v-col cols="12" md="5">
          <h1 class="primary--text">Our Mission</h1>
          <p>
            The first is to help foreign students receive the best Chinese
            education, and the second is to give Chinese teachers a platform to
            display their abilities. The third is to let foreigners understand
            better about Chinese culture to help foreigners build a bridge with
            China
          </p>
        </v-col>
      </v-row>
    </v-container>
    <v-container :class="sectionClass">
      <h1 class="primary--text">Our History</h1>
      <v-timeline>
        <v-timeline-item
          v-for="(item, i) in timelines"
          :key="i"
          :color="item.color"
        >
          <template #opposite>
            <span
              :class="`headline font-weight-bold ${item.color}--text`"
              v-text="item.year"
            ></span>
          </template>
          <div class="py-4">
            <h2 :class="`headline font-weight-bold mb-4 ${item.color}--text`">
              {{ item.title }}
            </h2>
            <div v-html="item.content"></div>
          </div>
        </v-timeline-item>
      </v-timeline>
    </v-container>
  </v-container>
</template>
<script>
import { Head } from '@inertiajs/inertia-vue'
import LayoutHome from '@layouts/Home.vue'
export default {
  name: 'AboutUs',
  components: {
    Head,
  },
  layout: LayoutHome,
  data() {
    return {
      timelines: [
        {
          color: 'cyan',
          year: '2018',
          title: "Company's Start",
          content:
            'XuYuan Class was founded in 2018. XuYuan Class is starting to come with an offline course system in West Surabaya, Indonesia',
        },
        {
          color: 'green',
          year: '2020',
          title: 'System Update and Native Teacher',
          content:
            'Due to the pandemic in 2019, we changed our teaching system to online and began to expand outside Surabaya. <br />In 2020, XuYuan Class added more native teachers due to the increasing demand for onilne teaching',
        },
        {
          color: 'pink',
          year: '2021',
          title: 'Become an Official Company in China',
          content:
            'In 2021, XuYuan Class was officially registered as an official company in China and now teaching more than 3000 hours per month',
        },
        {
          color: 'amber',
          year: '2022',
          title: 'Launch Website and Learning App',
          content:
            'In mid 2022, XuYuan Class will launch official website and learning app to help kindergarten students learn in a more fun ways',
        },
      ],
    }
  },
}
</script>
